import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Loader2, Database, Sparkles } from "lucide-react";

type IntegrationRagActionBarProps = {
  selectedCount: number;
  indexing?: boolean;
  analyzing?: boolean;
  indexProgress?: string | null;
  saveToLibrary: boolean;
  onSaveToLibraryChange: (value: boolean) => void;
  onIndexRaw: () => void;
  onAnalyze: () => void;
  disabled?: boolean;
  showAnalyze?: boolean;
};

export function IntegrationRagActionBar({
  selectedCount,
  indexing = false,
  analyzing = false,
  indexProgress,
  saveToLibrary,
  onSaveToLibraryChange,
  onIndexRaw,
  onAnalyze,
  disabled = false,
  showAnalyze = true,
}: IntegrationRagActionBarProps) {
  const busy = disabled || indexing || analyzing;

  return (
    <div className="space-y-3 rounded-md border bg-muted/20 px-3 py-3">
      <div className="flex flex-wrap items-center gap-3">
        <Button
          size="sm"
          variant="secondary"
          onClick={onIndexRaw}
          disabled={busy || selectedCount === 0}
        >
          {indexing ? (
            <Loader2 className="h-4 w-4 animate-spin mr-2" />
          ) : (
            <Database className="h-4 w-4 mr-2" />
          )}
          Embed RAG ({selectedCount})
        </Button>
        {showAnalyze && (
          <Button size="sm" onClick={onAnalyze} disabled={busy || selectedCount === 0}>
            {analyzing ? (
              <Loader2 className="h-4 w-4 animate-spin mr-2" />
            ) : (
              <Sparkles className="h-4 w-4 mr-2" />
            )}
            Analyze selected ({selectedCount})
          </Button>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Checkbox
          id="integration-save-library"
          checked={saveToLibrary}
          onCheckedChange={(v) => onSaveToLibraryChange(v === true)}
          disabled={busy}
        />
        <Label htmlFor="integration-save-library" className="text-sm font-normal cursor-pointer">
          Also save to Library (backup only, not used for chat RAG)
        </Label>
      </div>
      {indexProgress && (
        <p className="text-sm text-muted-foreground flex items-center gap-2">
          <Loader2 className="h-3 w-3 animate-spin" />
          {indexProgress}
        </p>
      )}
    </div>
  );
}
